import React, { useCallback, useState, useEffect } from "react";
import DetailSection from "../components/DetailSection";
import { useParams, useSearchParams } from "react-router-dom";
import { getDataCommon } from "../api/common";

const Playground = () => {
  const { type } = useParams();
  const [searchParams] = useSearchParams();
  const title = searchParams.get("title");

  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getDataCommon(`${type}.json`)
        .then((res) => {
          setPageData(res);
        })
        .catch((err) => console.log(err)),
    [setPageData, type]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return <DetailSection />;
};

export default Playground;
